import type { Rect } from "@/lib/math/rect";

export type ResizeHandle = "nw" | "n" | "ne" | "e" | "se" | "s" | "sw" | "w";
export type RotationHandle = "nw" | "ne" | "se" | "sw";

export function getResizeHandlePositions(bounds: Rect): Array<{ handle: ResizeHandle; x: number; y: number }> {
  const x1 = bounds.x;
  const y1 = bounds.y;
  const x2 = bounds.x + bounds.width;
  const y2 = bounds.y + bounds.height;
  const cx = bounds.x + bounds.width / 2;
  const cy = bounds.y + bounds.height / 2;

  return [
    { handle: "nw", x: x1, y: y1 },
    { handle: "n", x: cx, y: y1 },
    { handle: "ne", x: x2, y: y1 },
    { handle: "e", x: x2, y: cy },
    { handle: "se", x: x2, y: y2 },
    { handle: "s", x: cx, y: y2 },
    { handle: "sw", x: x1, y: y2 },
    { handle: "w", x: x1, y: cy },
  ];
}
